import { type FC, useState } from "react";

import { Button } from "src/components";
import { RICH_TEXT_COMPONENTS, Trans, useTranslation } from "src/translations";

type QuestionnaireWarningSectionProps = {
    translationKey: string;
    confirmed: boolean;
    isConfirming: boolean;
    onConfirm: () => void;
};

export const QuestionnaireWarningSection: FC<QuestionnaireWarningSectionProps> = ({
    translationKey,
    confirmed,
    isConfirming,
    onConfirm,
}) => {
    const { t } = useTranslation();
    const [checked, setChecked] = useState(false);

    return (
        <div className="flex flex-col gap-3 rounded-lg border border-primary p-4">
            <p className="font-semibold">{t(`verification.INVESTOR_QUESTIONNAIRE.result.warning.${translationKey}.title`)}</p>

            <div className="prose prose-sm">
                <Trans
                    i18nKey={`verification.INVESTOR_QUESTIONNAIRE.result.warning.${translationKey}.text`}
                    components={RICH_TEXT_COMPONENTS}
                />
            </div>

            {confirmed ? (
                <p className="text-sm font-medium text-brand">{t("verification.INVESTOR_QUESTIONNAIRE.result.warning.confirmedBadge")}</p>
            ) : (
                <>
                    <label className="flex items-start gap-2 text-sm">
                        <input type="checkbox" checked={checked} onChange={(event) => setChecked(event.target.checked)} className="mt-1" />
                        {t(`verification.INVESTOR_QUESTIONNAIRE.result.warning.${translationKey}.checkboxLabel`)}
                    </label>
                    <Button
                        type="button"
                        kind="outline"
                        size="compact"
                        className="self-start"
                        disabled={!checked}
                        isLoading={isConfirming}
                        onClick={onConfirm}
                    >
                        {t("verification.INVESTOR_QUESTIONNAIRE.result.warning.confirm")}
                    </Button>
                </>
            )}
        </div>
    );
};
